var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundraising({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.237,
    x2: 0.203,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90fcd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07c87a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fundraising",
    transform: "translate(-1018 -797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-bank",
    transform: "translate(1012 791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M59.333,66H12.667A6.686,6.686,0,0,1,6,59.333V12.667A6.686,6.686,0,0,1,12.667,6H59.333A6.686,6.686,0,0,1,66,12.667V59.333A6.686,6.686,0,0,1,59.333,66Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M37.3,37.394c0,6.591-6.436,7.415-7.621,7.415v3.625H26.629V44.809c-1.016-.165-8.129-.824-8.129-8.734h5.589c0,.824,0,4.614,4.234,4.614,3.557,0,3.557-2.8,3.557-3.131,0-5.932-12.194-3.461-12.194-12.689,0-5.6,5.25-7.415,7.621-7.415V13.5h3.048v3.955c1.863.165,7.113,1.648,7.113,8.569H31.879c0-1.483-.339-4.449-3.557-4.449a3,3,0,0,0-3.218,3.3C24.936,30.308,37.3,28,37.3,37.394Z",
    transform: "translate(8.181 5.202)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 60,
    height: 60,
    transform: "translate(1018 797)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundraising);
export default __webpack_public_path__ + "static/media/fundraising.3ae23436d03c6a529866aad7ed5ab2cf.svg";
export { ForwardRef as ReactComponent };